import { useAuth } from "@/context/AuthContext";
import { useHROptions } from "@/components/PeriodFilter";
import {
  Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle,
} from "@/components/ui/dialog";
import { UserCircle2 } from "lucide-react";

// First-open name picker (shared-link mode). Remembered in localStorage; "Change user" in header reopens it.
export default function UserSelect() {
  const { hrSelf, selectHR } = useAuth();
  const options = useHROptions(!hrSelf);
  if (hrSelf) return null;
  return (
    <Dialog open onOpenChange={() => {}}>
      <DialogContent className="max-w-sm [&>button]:hidden" data-testid="user-select-dialog">
        <DialogHeader>
          <DialogTitle className="font-heading">Apna naam select karo</DialogTitle>
          <DialogDescription>Aapki entries isi naam se save hongi. Baad me header se "Change user" kar sakte ho.</DialogDescription>
        </DialogHeader>
        <div className="grid gap-2 max-h-80 overflow-y-auto">
          {options.length === 0 && <div className="text-sm text-slate-500 text-center py-4">Loading HR list…</div>}
          {options.map((u) => (
            <button
              key={u.id}
              onClick={() => selectHR({ id: u.id, name: u.name })}
              className="flex items-center gap-3 px-4 py-2.5 rounded-lg border border-slate-200 hover:border-[var(--yc-navy)] hover:bg-slate-50 text-left transition-colors"
              data-testid={`select-hr-${u.id}`}
            >
              <UserCircle2 className="h-5 w-5 text-[var(--yc-emerald)]" />
              <span className="font-medium text-[var(--yc-navy)]">{u.name}</span>
            </button>
          ))}
        </div>
      </DialogContent>
    </Dialog>
  );
}
